export default __webpack_public_path__ + "static/darkVectorTablet-56f14799f8d43eed9d92501a24bbff13.png";